//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global ga */
import isEqual from 'lodash/isEqual';
import cloneDeep from 'lodash/cloneDeep';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import intersectionWith from 'lodash/intersectionWith';
import { createInstance } from 'vuex-pagination';
import {
  BLACK_FRIDAY_SLUG,
  SUMO_DAY_SLUG,
} from '@/constants/global';
import { filterAttributeDependencies } from '@/datalayer/helpers/attributes';
import { taxonomyTitle, extractBrowse } from '@/util/global';
import FilterIcon from '~/static/filter.svg';
import CampaignsMixin from '~/mixins/campaigns';

export default {
  name: 'Browse',
  mixins: [CampaignsMixin],
  props: {
    fullWidth: {
      type: Boolean,
      default: false,
    },
    fetchArgs: {
      type: Object,
      default: () => undefined, // undefined is intentional (sonarcube error)
    },
    queryArgs: {
      type: Object,
      default: () => undefined, // undefined is intentional (sonarcube error)
    },
    profile: {
      type: String,
      default: '',
    },
    canSort: {
      type: Boolean,
      default: true,
    },
    showResults: {
      type: Boolean,
      default: true,
    },
    showBrowseHeader: {
      type: Boolean,
      default: true,
    },
    canLoadMore: {
      type: Boolean,
      default: true,
    },
    filterCategories: {
      type: Boolean,
      default: true,
    },
    filterDealStatuses: {
      type: Boolean,
      default: true,
    },
    filterDealTypes: {
      type: Boolean,
      default: true,
    },
    filterSelectDeals: {
      type: Boolean,
      default: true,
    },
    maximumResults: {
      type: Number,
      default: null,
    },
    isSmartCollection: {
      type: Boolean,
      default: false,
    },
    group: {
      type: Object,
      default: () => undefined,
    },
    category: {
      type: Object,
      default: () => undefined,
    },
    subcategory: {
      type: Object,
      default: () => undefined,
    },
  },
  async fetch() {
    try {
      const opts = {
        pageFrom: 1,
        pageTo: 1,
        pageSize: 20,
        args: {
          filters: this.filters,
          maximumResults: this.maximumResults,
        },
      };

      const items = await this.controller.fetchRange(opts);
      if (this.isSearching && items.length === 1 && this.isSearchedDeal(items[0])) {
        if (this.$root.context.ssrContext) {
          this.$root.context.ssrContext.redirected = true;
          this.$root.context.ssrContext.res.writeHead(302, { Location: `${items[0].get_absolute_url}?query=${encodeURIComponent(this.searchQuery)}` });
          this.$root.context.ssrContext.res.end();
        } else if (process.browser) {
          window.location = `${items[0].get_absolute_url}?query=${encodeURIComponent(this.searchQuery)}`;
        }
      }
    } catch (ex) {
      // continue regardless of error
    }
  },
  data() {
    return this.resetData(this.$route?.query, this.$route?.params.pathMatch);
  },
  computed: {
    searchQuery: {
      get() {
        return this.filters.query;
      },
      set(newValue) {
        const filters = cloneDeep(this.filters);

        filters.query = newValue;
        this.filters = filters;
      },
    },
    selectedSort: {
      get() {
        return this.filters.sort;
      },
      set(newValue) {
        const filters = cloneDeep(this.filters);

        filters.sort = newValue;
        this.filters = filters;
      },
    },
    basePath() {
      if (this.isSmartCollection) {
        const existingLocation = window.location.pathname.split('/').filter(Boolean).filter((part) => !['expired', 'ending', 'all'].includes(part));
        return `/${existingLocation.join('/')}`;
      }

      const { group, category, subcategory } = this.filters.attributes;
      const parts = [];

      if (group) {
        parts.push(group);
      }

      if (category) {
        parts.push(category);
      }

      if (subcategory) {
        parts.push(subcategory);
      }

      if (!parts.length) {
        if (this.isSearching) {
          return '/search';
        }

        return '/browse';
      }

      return `/${parts.join('/')}`;
    },
    currentRegistryName() {
      /* eslint-disable no-underscore-dangle */
      if (this.pageDeals && this.pageDeals._meta) {
        const meta = this.pageDeals._meta;
        const { state } = this.$store;
        if (state.__paginatedResources && state.__paginatedResources.pageDeals) {
          const instance = this.$store.state.__paginatedResources.pageDeals.instances[meta.fullId];
          /* eslint-enable no-underscore-dangle */
          if (instance) {
            return instance.registryName;
          }
        }
      }

      return 'default';
    },
    currentRegistry() {
      const { state } = this.$store;
      /* eslint-disable no-underscore-dangle */
      if (state.__paginatedResources && state.__paginatedResources.pageDeals) {
        return this.$store.state.__paginatedResources.pageDeals.registry[this.currentRegistryName];
      }

      return undefined;
    },
    registryAggregations() {
      // aggregations are stored in the last item
      const registry = this.currentRegistry;

      if (registry) {
        const { items } = registry;

        // return last non-null item
        for (let i = items.length; i > 0; i -= 1) {
          if (items[i]) {
            return items[i];
          }
        }
      }

      return {};
    },
    bestDeal() {
      const { items } = this.pageDeals;

      if (items.length > 1) {
        return items[0];
      }

      return null;
    },
    totalItems() {
      const { total } = this.pageDeals;

      // items minus aggregations
      return total - 1;
    },
    totalPages() {
      const len = this.totalItems;

      return (len ? Math.ceil(len / this.pageDeals.pageSize) : 1);
    },
    results() {
      const { items } = this.pageDeals;

      if (this.isSearching && items.length > 2) {
        // in search mode trim the best deal
        return items.slice(1, -1);
      }

      // ignore aggregations
      if (items.length > 1) {
        return items.slice(0, -1);
      }

      return [];
    },
    hasResults() {
      const { items } = this.pageDeals;

      if (this.isSearching) {
        // if we are searching we only have results if we have best deal + 1 (+ aggregations)
        return (items.length > 2);
      }

      // non-search mode just always let component say results
      return true;
    },
    isSearching() {
      return !!this.searchQuery;
    },
    filtersAttribute: {
      get() {
        return this.showMobileFilter ? this.mobileFilters : this.filters;
      },
      set(newValue) {
        if (this.showMobileFilter) {
          this.mobileFilters = newValue;
        } else {
          this.filters = newValue;
        }
      },
    },
    sortDisplayName() {
      return (this.dealSort.filter((s) => s.value === this.selectedSort)[0] || {}).display;
    },
    currentUser() {
      return this.$store.state.session.user;
    },
    subtitle() {
      if (this.searchQuery) {
        if (this.showTrendingFallback) {
          return `Sorry, we couldn't find any results matching "${this.searchQuery}"`;
        }
        return `Products matching "${this.searchQuery}"`;
      }

      if (this.group) {
        if (this.subcategory) {
          return taxonomyTitle(this.subcategory.name, this.group.name);
        } if (this.category) {
          return taxonomyTitle(this.category.name, this.group.name);
        }
        return `Browse ${this.group.name.toLowerCase()}`;
      }

      return 'Browse products';
    },
    pageDeals: createInstance('pageDeals', {
      pageFrom: 1,
      pageTo: 1,
      pageSize: 20,
      args() {
        return {
          filters: this.filters,
          maximumResults: this.maximumResults,
        };
      },
    }),
  },
  watch: {
    registryAggregations() {
      if (!this.pageDeals.loading) {
        this.aggregations = cloneDeep(this.registryAggregations);
      }
    },
    queryArgs(to, from) {
      if (!isEqual(from, to)) {
        const data = this.resetData(to, this.$route?.params.pathMatch);
        Object.keys(data).forEach((key) => {
          this.$set(this, key, data[key]);
        });
      }
    },
    fetchArgs(to, from) {
      if (!isEqual(from, to)) {
        const data = this.resetData(this.$route?.query, this.$route?.params.pathMatch);
        Object.keys(data).forEach((key) => {
          this.$set(this, key, data[key]);
        });
      }
    },
    group(to) {
      const newFilters = cloneDeep(this.filters);

      newFilters.attributes = {
        ...newFilters.attributes,
        group: to?.value,
        category: undefined,
        subcategory: undefined,
      };

      this.filters = newFilters;
    },
    category(to) {
      const newFilters = cloneDeep(this.filters);

      newFilters.attributes = {
        ...newFilters.attributes,
        category: to?.value,
        subcategory: undefined,
      };

      this.filters = newFilters;
    },
    subcategory(to) {
      const newFilters = cloneDeep(this.filters);

      newFilters.attributes = {
        ...newFilters.attributes,
        subcategory: to?.value,
      };

      this.filters = newFilters;
    },
    '$store.state.__paginatedResources.pageDeals.currentRequest': function () {
      if (this.$store.state.__paginatedResources.pageDeals.currentRequest !== null && this.pageDeals.pageTo === 1) { // eslint-disable-line no-underscore-dangle, max-len
        this.scrollToSubtitle();
      }
    },
    showMobileFilter(value) {
      this.toggleOverlayVisibility(value === true);
    },
    mobileFilters: {
      deep: true,
      handler() {
        this.updateMobileResultCount();
      },
    },
    filters: {
      deep: true,
      handler() {
        this.updateCurrentUrl();
      },
    },
  },
  created() {
    this.controller = this.$store.createResource('pageDeals', this.fetchDeals);
  },
  beforeMount() {
    this.handleDebouncedScroll = debounce(this.handleScroll, 100);
    window.addEventListener('scroll', this.handleDebouncedScroll);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleDebouncedScroll);
  },
  methods: {
    resetData(query, pathMatch) {
      const q = query || {};
      const params = extractBrowse(pathMatch);
      // get defaults from profile
      const defaults = this.profileDefaults();

      // override defaults with those specified on URL
      if (q.query) {
        defaults.query = q.query;
      }

      if (q.rating) {
        defaults.average_rating = q.rating;
      }

      if (q.tags) {
        defaults.tags = q.tags;
      }

      if (q.status) {
        defaults.status = q.status;
      }

      if (q.sort) {
        defaults.sort = q.sort;
      }

      if (q.type) {
        defaults.type = q.type;
      }

      if (!defaults.price_range) {
        defaults.price_range = {
          type: 'custom',
        };
      }

      if (q.price_type === 'free') {
        defaults.price_range.type = 'free';
      } else {
        if (typeof q.price_from !== 'undefined') {
          defaults.price_range.price_from = q.price_from;
        }

        if (typeof q.price_to !== 'undefined') {
          defaults.price_range.price_to = q.price_to;
        }
      }

      // select only sets marketplace = false
      if (q.select && String(q.select) === 'true') {
        defaults.marketplace = false;
      }

      let attributes = {};
      const { valid_attributes: validAttributes } = this.$store.state.browse;
      validAttributes.forEach((attrib) => {
        let value = q[attrib.slug];

        if (typeof value === 'undefined' && ['group', 'category', 'subcategory'].includes(attrib.slug)) {
          value = params[attrib.slug];
        }
        if (value) {
          if (attrib.type === 'enumeration') {
            if (attrib.multiple === true) {
              value = String(value).split(',');
              attributes[attrib.slug] = intersectionWith(
                value,
                attrib.options,
                (a, b) => a === b,
              );
            } else {
              value = attrib.options.find((o) => o === value);
              if (value) {
                attributes[attrib.slug] = value;
              }
            }
          } else if (attrib.type === 'boolean') {
            attributes[attrib.slug] = [true, 'true'].includes(value);
          }
        }
      });

      attributes = filterAttributeDependencies(this.$store.state.browse.attributes, attributes);

      if (q.bf && String(q.bf) === 'true' && this.isCampaignActive(BLACK_FRIDAY_SLUG)) {
        defaults.bf = true;
      }

      if (q.sumoday && String(q.sumoday) === 'true' && this.isCampaignActive(SUMO_DAY_SLUG)) {
        defaults.sumoday = true;
      }

      return {
        aggregations: {},
        FilterIcon,
        dealStatus: [
          { value: 'current', display: 'Current' },
          { value: 'ending', display: 'Ending' },
          { value: 'expired', display: 'Expired' },
          { value: 'all', display: 'All' },
        ],
        dealType: [
          { value: 'lifetime-deal', display: 'Lifetime deal' },
          { value: 'annual', display: 'Annual' },
          { value: 'freebie', display: 'Freebie' },
          { value: 'subscription', display: 'Subscription' },
          { value: 'digital-download', display: 'Digital download' },
          { value: 'all', display: 'All plan types' },
        ],
        displayCategories: false,
        displayDealStatus: false,
        displayDealType: false,
        mobileResults: null,
        restoreSelectedSort: null,
        dealSort: [
          { value: 'recommended', display: 'Recommended' },
          { value: 'latest', display: 'Latest' },
          { value: 'review_count', display: '# of customer ratings' },
          { value: 'rating', display: 'Avg customer rating' },
          { value: 'price_low', display: 'Price: low to high' },
          { value: 'price_high', display: 'Price: high to low' },
          { value: 'ending', display: 'Ending soon' },
        ],
        isInfiniteScrollEnabled: false,
        showTrendingFallback: false,
        trendingCategories: [],
        showMobileFilter: false,
        filters: {
          query_args: cloneDeep(this.fetchArgs),
          sort: defaults.sort || 'recommended',
          query: defaults.query || '',
          plan_type: defaults.type || 'all',
          status: defaults.status || (defaults.query ? 'all' : 'current'),
          price_range: defaults.price_range || {
            type: 'custom',
          },
          average_rating: defaults.average_rating || null,
          marketplace: defaults.marketplace,
          bf: defaults.bf,
          sumoday: defaults.sumoday,
          categories: (defaults.tags || '').split(',').filter(Boolean),
          attributes,
        },
        mobileFilters: {},
        infiniteScrollMaxPages: 3,
      };
    },
    isSearchedDeal(deal) {
      return (
        this.searchQuery
        && deal
        && this.searchQuery.toLowerCase().localeCompare(deal.public_name.toLowerCase()) === 0
      );
    },
    async updateMobileResultCount() {
      const { fetchDealsCount } = await import(
        /* webpackChunkName: 'datalayer-helpers-deals' */ '@/datalayer/helpers/deals'
      );

      const dealArgs = {
        profile: this.profile,
        $store: this.$store,
        $cachios: this.$cachios,
        args: {
          filters: this.mobileFilters,
          maximumResults: this.maximumResults,
        },
      };

      this.mobileResults = await fetchDealsCount(dealArgs);
    },
    openMobileFilter() {
      this.resetMobileFilter();
      this.showMobileFilter = true;
    },
    resetMobileFilter() {
      this.mobileFilters = cloneDeep(this.filters);
    },
    applyMobileFilter() {
      this.filters = cloneDeep(this.mobileFilters);
      this.showMobileFilter = false;
    },
    handleScroll() {
      const CARD_OFFSET = 400; // ~ Max height of card
      // Check if exceeded max number of infinite scroll "pages"
      if (this.pageDeals.pageTo >= this.infiniteScrollMaxPages) return;

      const { offsetTop, clientHeight } = get(this, ['$refs', 'browseResults', '$el'], {});

      if (!(offsetTop && clientHeight)) return;

      const scrollPos = window.scrollY + window.innerHeight;
      const browseElBottom = offsetTop + clientHeight;

      if (!(scrollPos > browseElBottom - CARD_OFFSET)) return;

      // PaginateDeals takes care of checking if loading more deals, if there are more deals, etc
      this.paginateDeals();
    },
    profileDefaults() {
      const defaults = {};

      Object.keys(this.fetchArgs || {}).forEach((key) => {
        const val = this.fetchArgs[key];
        if (key.indexOf('profile{') === 0) {
          key = key.slice(8, -1); // eslint-disable-line no-param-reassign
        }
        if (key.indexOf('product_tags') === 0) {
          key = 'tags'; // eslint-disable-line no-param-reassign
        }
        defaults[key] = val;
      });

      // turn profile string into a true boolean
      if (typeof defaults.marketplace !== 'undefined') {
        defaults.marketplace = (['true', '1'].includes(String(defaults.marketplace).toLowerCase()));
      }

      return defaults;
    },
    async fetchDeals({ page, pageSize, args }) {
      const { fetchDeals } = await import(
        /* webpackChunkName: 'datalayer-helpers-deals' */ '@/datalayer/helpers/deals'
      );

      const dealArgs = {
        profile: this.profile,
        $store: this.$store,
        $cachios: this.$cachios,
        page,
        pageSize,
        args,
      };

      const data = await fetchDeals(dealArgs);

      if (
        process.browser
        && this.isSearching
        && data.ret.data.length === 1
        && this.isSearchedDeal(data.ret.data[0])
      ) {
        window.location = `${data.ret.data[0].get_absolute_url}?query=${encodeURIComponent(this.searchQuery)}`;
      }

      this.showTrendingFallback = data.showTrendingFallback;
      this.trendingCategories = data.trendingCategories;

      return data.ret;
    },
    compareTags(sTags, dTags) {
      let selectedTags = sTags || [];
      let defaultTags = dTags || [];
      // check for array vs string
      if (typeof selectedTags === 'string') selectedTags = selectedTags.split(',');
      if (typeof defaultTags === 'string') defaultTags = defaultTags.split(',');
      // clone them so we leave the original vue watchers alone
      selectedTags = [...selectedTags];
      defaultTags = [...defaultTags];
      // sort alphabetically
      selectedTags.sort((a, b) => a.localeCompare(b));
      defaultTags.sort((a, b) => a.localeCompare(b));

      return selectedTags.join(',') === defaultTags.join(',');
    },
    updateCurrentUrl() {
      const query = [];
      const uriQuery = this.$route.query || {};

      // setup defaults from profile so we don't need to use these on URL bar
      const defaults = this.profileDefaults();

      if (!('sort' in defaults)) {
        defaults.sort = this.dealSort[0].value;
      }

      if (!('type' in defaults)) {
        defaults.type = 'all';
      }

      if (!('status' in defaults)) {
        defaults.status = this.isSearching ? 'all' : 'current';
      }

      if (['expired', 'ending', 'all', 'current'].includes(this.filters.status) && this.filters.status !== defaults.status) {
        query.push(`status=${this.filters.status}`);
      }

      if (this.filters.bf && this.filters.bf !== defaults.bf) {
        query.push('bf=true');
      }

      if (this.filters.sumoday && this.filters.sumoday !== defaults.sumoday) {
        query.push('sumoday=true');
      }

      if (
        this.filters.average_rating
        && Number(this.filters.average_rating) > 0
        && Number(this.filters.average_rating) < 5
      ) {
        query.push(`rating=${Number(this.filters.average_rating)}`);
      }

      if (this.filters.plan_type && this.filters.plan_type !== defaults.type) {
        query.push(`type=${this.filters.plan_type}`);
      }

      if (
        this.filters.categories.length && !this.compareTags(this.filters.categories, defaults.tags)
      ) {
        query.push(`tags=${this.filters.categories.join(',')}`);
      }

      if (this.selectedSort && this.selectedSort !== defaults.sort) {
        query.push(`sort=${this.selectedSort}`);
      }

      if (this.searchQuery && this.searchQuery !== defaults.query) {
        query.push(`query=${this.searchQuery}`);
      }

      if (this.filters.marketplace === false && this.filters.marketplace !== defaults.marketplace) {
        query.push('select=true');
      }

      if (this.filters.price_range.type === 'free') {
        query.push('price_type=free');
      } else if (this.filters.price_range.type === 'custom') {
        if (this.filters.price_range.price_from) {
          query.push(`price_from=${this.filters.price_range.price_from}`);
        }

        if (this.filters.price_range.price_to) {
          query.push(`price_to=${this.filters.price_range.price_to}`);
        }
      }

      if (this.filters.attributes) {
        Object.keys(this.filters.attributes).forEach((key) => {
          if (!this.isSmartCollection && ['group', 'category', 'subcategory'].includes(key)) return;

          const value = this.filters.attributes[key];
          const attrib = this.$store.state.browse.attributes.find((a) => a.slug === key);

          if (value) {
            if (attrib.type === 'enumeration') {
              if (attrib.type_options.multiple === true) {
                query.push(`${key}=${value.join(',')}`);
              } else {
                query.push(`${key}=${value}`);
              }
            } else if (attrib.type === 'boolean' && value === true) {
              query.push(`${key}=${value}`);
            }
          }
        });
      }
      // retain any UTM params
      Object.keys(uriQuery).forEach((key) => {
        const val = uriQuery[key];
        if (key.toLowerCase().startsWith('utm_')) {
          query.push(`${key}=${val}`);
        }
      });

      let url = this.basePath;
      if (query.length) {
        url += `?${query.join('&')}`;
      }
      this.$router.push(url);
    },
    clearSearchQuery() {
      this.searchQuery = null;
      this.$store.commit('setAutocompleteQuery', this.searchQuery);
    },
    setSearchQuery(e) {
      const query = e.target.value ? String(e.target.value).trim() : null;

      // when we start searching, switch to recommended mode
      if (query && this.restoreSelectedSort === null) {
        this.restoreSelectedSort = this.selectedSort;
        this.selectedSort = 'recommended';
      } else if (!query) {
        // restore selected sort prior to searching
        this.selectedSort = this.restoreSelectedSort || 'recommended';
        this.restoreSelectedSort = null;
      }
      this.searchQuery = query;
    },
    paginateDeals() {
      if (!this.pageDeals.loading && this.pageDeals.pageTo < this.totalPages) {
        this.pageDeals.pageTo += 1;
      }
    },
    // Use object to keep compatibility with Browse.vue
    onClickSelectSort(option) {
      this.selectedSort = option && option.value;
    },
    // Update Google analytics site search, added larger debounce to reduce logging partial queries
    updateGA: debounce(function updateGA() {
      if (typeof ga !== 'undefined' && ga && this.searchQuery) {
        ga('send', 'pageview', `${this.basePath}/?query=${this.searchQuery}`);
      }
    }, 1000),
    scrollToSubtitle() {
      window.scroll({ top: 0, left: 0, behavior: 'smooth' });
      /*
      const el = this.$refs.subtitle;
      const navEle = document.getElementsByClassName('navbar-expand-lg')[0];
      const banner = document.getElementsByClassName('appsumo-banner')[0];
      if (el && navEle) {
        let offset = navEle.clientHeight;
        if (banner) {
          offset += banner.clientHeight;
        }
        window.scroll({ top: (el.offsetTop - offset), left: 0, behavior: 'smooth' });
      }
      */
    },
    toggleOverlayVisibility(show) {
      // jw: first, let's get the overlay and ensure we were able to find it.
      const overlay = document.getElementById('sumo-main-overlay');
      if (!overlay) {
        return;
      }

      // jw: next, if the overlay is already in the state we want we can short out.
      if (show === overlay.classList.contains('active')) {
        return;
      }

      // jw: finally, we can just update the classes and call it a day.
      if (show) {
        overlay.classList.add('active');
        overlay.classList.add('full');

        overlay.addEventListener('click', this.closeMobileFilters);
      } else {
        overlay.classList.remove('active');
        overlay.classList.remove('full');

        overlay.removeEventListener('click', this.closeMobileFilters);
      }

      document.body.classList.toggle('overflow-hidden');
    },
    /**
     * Prevent scrolling for mobile using only CSS doesn not work on iOS with Safari,
     * so we disable the touchmove to prevent scrolling while having the overlay enable
     * https://hynchrstn.wordpress.com/2021/01/12/disable-ios-scrolling-overflow-hidden-is-not-working/
     */
    preventTouchMove(event) {
      event.preventDefault();
    },
    closeMobileFilters() {
      this.showMobileFilter = false;
    },
  },
};
